import React from 'react';
import { cn } from 'utils/ui/classes';
export function TypingIndicator({ className, dotSize = 'md', color = 'muted', }) {
    const sizeClasses = {
        sm: 'w-1.5 h-1.5',
        md: 'w-2 h-2',
        lg: 'w-3 h-3',
    };
    const colorClasses = {
        gray: 'bg-gray-600',
        primary: 'bg-primary',
        muted: 'bg-muted-foreground/60',
    };
    const dotClass = cn(sizeClasses[dotSize], colorClasses[color], 'rounded-full animate-bounce');
    return (React.createElement("div", { className: cn('flex space-x-1', className) },
        React.createElement("div", { className: dotClass }),
        React.createElement("div", { className: dotClass, style: { animationDelay: '0.1s' } }),
        React.createElement("div", { className: dotClass, style: { animationDelay: '0.2s' } })));
}
